<template>
  <div class="articleManage">
    <!-- 文章管理 -->
    <div class="bodycontent">
      <!-- 头部菜单 -->
      <div class="option">
        <div class="left">
          <el-button type="primary" icon="el-icon-setting" @click="showSet=true,store=true">发布文章</el-button>
        </div>
      </div>
      <!-- 开卡记录列表 -->
      <el-table :data="listData">
        <el-table-column label="标题" prop="title"></el-table-column>
        <el-table-column label="发布时间" prop="create_time"></el-table-column>
        <el-table-column label="封面图">
          <template slot-scope="scope">
            <img :src="scope.row.cover_url" style="width:80px;height:60px;"/>
          </template>
        </el-table-column>
        <el-table-column label="内容">
          <template slot-scope="scope">
            <p class="textCont" v-html="scope.row.content"></p>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" fixed="right" width="120px">
          <template slot-scope="scope">
            <el-button type="text" @click="editItem(scope.row)">编辑</el-button>
            <el-button type="text" @click="delItem(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页按钮 -->
      <div class="Otherpage">
        <el-pagination
          layout="prev, pager, next, total, jumper"
          :current-page="page"
          :total="total"
          :page-size="10"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
      <el-dialog :visible.sync="showSet" @close="showSet=false" title="发布文章" width="60%">
        <div>
          <el-row>
            <el-col :span="4">
              <div class="grid-content bg-purple">标题：</div>
            </el-col>
            <el-col :span="12">
              <div class="grid-content bg-purple-light">
                <el-input v-model="headline" placeholder="请输入内容"></el-input>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4">
              <div class="grid-content bg-purple">封面图：</div>
            </el-col>
            <el-col :span="12">
              <div class="grid-content bg-purple-light">
                <el-upload
                  class="avatar-uploader"
                  action
                  :show-file-list="false"
                  :http-request="uploadSectionFile"
                >
                  <img v-if="imageUrl" :src="imageUrl" class="avatar" />
                  <i
                    v-else
                    class="el-icon-plus avatar-uploader-icon"
                    v-loading.fullscreen.lock="fullscreenLoading"
                  ></i>
                </el-upload>
              </div>
            </el-col>
          </el-row>
        </div>
        <el-row>
          <el-col :span="4">
            <div class="grid-content bg-purple">主要内容：</div>
          </el-col>
          <el-col :span="20">
            <div class="grid-content bg-purple-light">
              <EditorBar @change="changeeditor" v-model="content" style="width:100%"></EditorBar>
              <!-- <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 20}" placeholder="请输入内容" v-model="content"></el-input> -->
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4">
            <div class="grid-content bg-purple"></div>
          </el-col>
          <el-col :span="20">
            <div class="grid-content bg-purple">
              <el-button @click="showSet = false">取消</el-button>
              <el-button type="primary" @click="confirms">确定</el-button>
            </div>
          </el-col>
        </el-row>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import EditorBar from "@Components/public/wangEnduit";
import { addImage } from "@/api/mall";
import { mapGetters } from "vuex";
import { getOpenSet, setOpenSet, addArticle, ArticleList, ArticleDel, ArticleEdit } from "@/api/vip";
export default {
  computed: {
    ...mapGetters(["token", "app_id", "merch_id"])
  },
  components: {
    EditorBar
  },
  data() {
    return {
      fullscreenLoading: false,
      content: "",
      imageUrl: "",
      headline: "",
      cover: "",
      dataArray: "",
      isClear: false,
      listData: [], //列表
      keyword: "", //关键字筛选
      total: 0,
      showSet: false,
      page: 0,
      store: false, // true添加，false编辑,
      ids: "",
    };
  },
  mounted() {
    this.getList();
  },
  watch: {
    store(val) {
      if(val == true) {
        this.headline = "";
        this.content = "";
        this.cover = "";
        this.imageUrl = "";
      }
    }
  },
  methods: {
    // 获取编辑器内容
    changeeditor(value) {
      this.content = value;
      console.log(value);
    },
    getList() {
      this.page++;
       let data = {
        token: this.token,
        app_id: this.app_id,
        merch_id: "",
        store_id: "",
        page: this.page
      }
      ArticleList(data).then( res => {
        console.log(res);
        this.total = res.data.total_num;
        this.listData = res.data.result;
      })
    },
    confirms() {
      if( this.store) {
        this.addArticle()
      } else {
        this.editArticle()
      }
    },
    addArticle() {
      // 添加文章
      if(this.headline == ""||this.content==""||this.cover=="") {
        this.$message.error('内容不能为空');
      } else {
        let data = {
          token: this.token,
          app_id: this.app_id,
          merch_id: "",
          store_id: "",
          title: this.headline,
          content: this.content,
          cover: this.cover
        }
        addArticle(data).then(res => {
          console.log(res);
          this.$message({
            message: res.msg,
            type: 'success'
          });
          this.showSet = false;
          this.page = 0;
          this.getList();
          this.headline = "";
          this.content = "";
          this.cover = "";
          this.imageUrl = "";
        })
      }
      
    },
    editArticle() {
      // 编辑文章
      if(this.headline == ""||this.content==""||this.cover=="") {
        this.$message.error('内容不能为空');
      } else {
        let data = {
          token: this.token,
          app_id: this.app_id,
          id: this.ids,
          title: this.headline,
          content: this.content,
          cover: this.cover
        }
        ArticleEdit(data).then(res => {
          console.log(res);
          this.$message({
            message: res.msg,
            type: 'success'
          });
          this.showSet = false;
          this.page = 0;
          this.getList();
          this.headline = "";
          this.content = "";
          this.cover = "";
          this.imageUrl = "";
        })
      }
      
    },
    // 自定义上传文件
    uploadSectionFile(content) {
      this.fullscreenLoading = true;
      let data = new FormData();
      data.append("token", this.token);
      data.append("image", content.file);
      addImage(data).then(res => {
        this.fullscreenLoading = false;
        this.imageUrl = res.data.url;
        this.cover = res.data.id
      });
    },
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    search() {},
    // 编辑器
    editItem(val) {
      this.ids = val.id;
      this.headline = val.title;
      this.content = val.content;
      this.cover = val.cover;
      this.imageUrl = val.cover_url;
      this.showSet = true;
      this.store = false
    },
    //跳页
    handleCurrentChange(p) {
      
    },

    //删除
    delItem(i) {
      ArticleDel({
        token: this.token,
        app_id: this.app_id,
        id: i
      }).then( res => {
        console.log(res);
         this.page = 0;
          this.getList();
      })
    }
  }
};
</script>
<style lang="scss" scoped>
.articleManage {
  padding: 10px 55px 30px 0;
  // height: calc(100vh - 102px);
  .textCont {
    width: 100%;
    height: 50px;
    line-height: 25px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
  .grid-content {
    min-height: 36px;
    margin-top: 15px;
    font-size: 16px;
    .width100 {
      width: 100%;
    }
  }
  .bg-purple {
    text-align: right;
  }
  .bodycontent {
    position: relative;
    padding: 0px 27px 0;
    font-size: 14px;
    height: 96%;
    border: 1px solid #f1f1f1;
    box-shadow: 0 0 3px #f1f1f1;
    display: flex;
    flex-direction: column;
    .option {
      height: 79px;
      line-height: 79px;
      display: flex;
      .left {
        flex: 1;
      }
      .right {
        text-align: right;
        span {
          margin-left: 30px;
          .el-select {
            width: 150px;
          }
        }
      }
    }
    // table
    .el-table {
      flex: 1;
      box-shadow: 0 0 3px #f1f1f1;
      padding-left: 10px;
    }
    .level_img {
      width: 40px;
      height: 40px;
      border-radius: 20px;
    }
    //表格中的商品内容
    .table_line {
      height: 20px;
      line-height: 20px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    //分页
    .Otherpage {
      height: 34px;
      width: 200px;
      line-height: 34px;
    }
  }
}
</style>

<style lang="scss">
.articleManage {
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
}
</style>
